<div class="navigation navigation__top">
    <div class="navigation__text">
        <div class="navigation__open_fold">
            <a [hidden]="isOpen"
                ><i
                    (click)="toggleFoldMenu()"
                    class="zmdi zmdi-menu"></i
            ></a>
            <a [hidden]="!isOpen"
                ><i
                    (click)="toggleFoldMenu()"
                    class="zmdi zmdi-close"></i
            ></a>
        </div>
        <span (click)="toggleFoldMenu()">Menu</span>
    </div>
    <div class="navigation__image">
        <img
            style="cursor: pointer"
            src="assets/images/logo.png"
            alt=""
            aria-hidden="false"
            (click)="goToUrl('/')" />
    </div>
    <div
        class="navigation__top__icons"
        *ngIf="$userData | async as userData">
        <div
            *ngFor="let rightMenu of rightNavigation"
            class="navigation__top__icon"
            (click)="rightMenu.callFunc(rightMenu.route!)"
            title="{{ rightMenu.name === '' ? userData.firstName + ' ' + userData.lastName : (rightMenu.name | translate) }}">
            <i
                *ngIf="!rightMenu.iconIsImage"
                class="{{ rightMenu.icon }}"></i>
            <img
                *ngIf="rightMenu.iconIsImage"
                [src]="rightMenu.icon"
                [alt]="rightMenu.alt ?? ''" />
            <sera-items-count
                *ngIf="rightMenu.name === 'PAGE.GENERAL.WORK_BASKET.LBL'"
                styleClass="item-count item-count--red counter-items"
                [itemsCount]="$workstockCounter | async"
                [loading]="$loadingWorkstockCounter | async"></sera-items-count>
            <sera-items-count
                *ngIf="rightMenu.name === 'DWSM.DASHBOARD.HEADER.LBL'"
                styleClass="item-count item-count--red counter-items"
                [itemsCount]="$dwsmCounter | async"
                [loading]="$loadingDWSMCounter | async"></sera-items-count>
        </div>
    </div>
</div>
<div
    class="navigation navigation__left"
    *ngIf="!isOpen">
    <ng-container *ngIf="$userPermissions | async as permissions">
        <ng-container *ngIf="$userRole | async as role">
            <!-- (emitValueMenuObj) is the event emitter from that send value to our getObj function and then send it to app fold menu through leftNav obj-->
            <nav-menu
                [permissions]="permissions"
                [role]="role"
                [goToUrl]="goToUrl"
                (emitValueMenuObj)="getObjFromNavMenu($event)">
            </nav-menu>
        </ng-container>
    </ng-container>
    <div class="navigation__left__logout">
        <a (click)="logout()"> <i class="zmdi zmdi-power"></i></a>
    </div>
</div>
<div
    *ngIf="isOpen"
    class="fold-menu">
    <fold-menu
        [leftNav]="leftNavObject"
        [goToUrl]="goToUrl"
        [logout]="logout"></fold-menu>
</div>
<ng-container *ngIf="$workstockFavoriteCounter | async"></ng-container>
